import { inputStyles } from 'common/components/Input';
import { styledScrollbar } from 'common/layout';
import styled from 'styled-components';

export const TextArea = styled.textarea`
  ${inputStyles};
  resize: none;
  ${styledScrollbar};
`;
